module.exports = __webpack_public_path__ + "img/MELA_NK.0b3c2a1c.png";